export default {
  'get-list': {
    method: 'post',
    url: '/trip/list'
  },
  add: {
    method: 'post',
    url: '/trip'
  },
  update: {
    method: 'put',
    url: '/trip/ID'
  },
  updateModerationStatus: {
    method: 'put',
    url: '/trip/moderation-status/ID'
  },
  delete: {
    method: 'delete',
    url: '/trip'
  },
  archive: {
    method: 'delete',
    url: '/trip/archive'
  },
  finds: {
    method: 'get',
    url: '/trip/find?key=KEY'
  },
  detail: {
    method: 'get',
    url: '/trip/ID'
  }
}
